import { UserAddOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import DealCreateMenu from 'automations/components/Nodes/DealCreateMenu';
import { type DealCreateNodeType } from 'automations/types/nodeTypes';
import { didNodeSyncToServer } from 'automations/utils/node';
import { useMemo } from 'react';

import { type TriggerNodeReturnProps } from './useTriggerNodeConfig';

export default function useDealCreate(node: NodeProps<DealCreateNodeType>): TriggerNodeReturnProps {
  const isSyncedToServer = didNodeSyncToServer(node);

  const errorMessages: string[] = [
    !isSyncedToServer && 'Save the node before adding new nodes',
  ].filter(Boolean) as string[];
  const hasErrors = errorMessages.length > 0;

  const AdditionalUI = useMemo(() => <DealCreateMenu node={node} />, [node]);

  return {
    icon: UserAddOutlined,
    hasErrors,
    errorMessages,
    AdditionalUI,
  };
}
